import script from "./jiaoxuechangdiduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./jiaoxuechangdiduotiao.vue?vue&type=script&setup=true&lang=js"

import "./jiaoxuechangdiduotiao.vue?vue&type=style&index=0&id=2f7f7e81&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7f7e81"]])

export default __exports__